/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Status_ReadingInputs */

const en_import_status_reading = /** @type {(inputs: Import_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading…`)
};

const de_import_status_reading = /** @type {(inputs: Import_Status_ReadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gelesen…`)
};

/**
* | output |
* | --- |
* | "Reading…" |
*
* @param {Import_Status_ReadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_reading = /** @type {((inputs?: Import_Status_ReadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_ReadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_reading(inputs)
	return en_import_status_reading(inputs)
});